/* unplugin-vue-components disabled */import { render } from "./recommend.vue?vue&type=template&id=2a25bd6c&scoped=true"
import script from "./recommend.vue?vue&type=script&lang=js"
export * from "./recommend.vue?vue&type=script&lang=js"

import "./recommend.vue?vue&type=style&index=0&id=2a25bd6c&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a25bd6c"]])

export default __exports__